import { MapPin } from "lucide-react";
import { CityData, cityData } from "@/utils/cityData";
import { PrefetchLink } from "@/components/PrefetchLink";

interface CityCrossLinksProps {
  currentCity: CityData;
}

const CityCrossLinks = ({ currentCity }: CityCrossLinksProps) => {
  // Hole alle anderen Städte (max 8 für bessere UX)
  const otherCities = Object.values(cityData)
    .filter(city => city.slug !== currentCity.slug)
    .slice(0, 8);

  return (
    <section className="py-8 sm:py-12 lg:py-16">
      <div className="container mx-auto px-3 sm:px-4 lg:px-8">
        <div className="max-w-5xl mx-auto">
          <div className="text-center mb-6 sm:mb-8 lg:mb-10">
            <h2 className="text-xl sm:text-2xl lg:text-3xl font-bold mb-3 sm:mb-4">
              Cyberversicherung auch in Ihrer Nähe
            </h2>
            <p className="text-sm sm:text-base text-muted-foreground">
              Entdecken Sie unseren Cyberschutz für Arztpraxen in weiteren deutschen Städten
            </p>
          </div>

          <div className="grid grid-cols-2 sm:grid-cols-3 lg:grid-cols-4 gap-2.5 sm:gap-3 lg:gap-4">
            {otherCities.map((city) => (
              <PrefetchLink
                key={city.slug}
                to={`/cyberversicherung/${city.slug}`}
                className="group flex items-center gap-2 sm:gap-2.5 p-3 sm:p-4 bg-card/30 backdrop-blur-sm border border-border/50 rounded-lg hover:border-accent/50 hover:bg-card/50 transition-all min-h-[48px] sm:min-h-[56px]"
              >
                <MapPin className="w-4 h-4 sm:w-5 sm:h-5 text-accent flex-shrink-0" />
                <div className="flex flex-col min-w-0">
                  <span className="text-xs sm:text-sm font-semibold text-foreground truncate">
                    {city.name}
                  </span>
                  <span className="text-[10px] sm:text-xs text-muted-foreground truncate">
                    {city.stats.practiceCount}+ Praxen
                  </span>
                </div>
              </PrefetchLink>
            ))}
          </div>

          <div className="mt-6 sm:mt-8 text-center">
            <PrefetchLink
              to="/cyberversicherung"
              className="inline-flex items-center gap-2 px-4 sm:px-6 py-2.5 sm:py-3 bg-accent/10 border border-accent/30 rounded-lg hover:bg-accent/20 transition-all text-foreground font-semibold text-xs sm:text-sm lg:text-base min-h-[44px]"
            >
              <MapPin className="w-4 h-4 sm:w-5 sm:h-5" />
              Alle Städte anzeigen
            </PrefetchLink>
          </div>
        </div>
      </div>
    </section>
  );
};

export default CityCrossLinks;
